import { JsonSerializable } from '@/util/object/JsonSerializable'

export class ReferenceLineItemResponse extends JsonSerializable {
  /** @type {number} */
  #lineNumber
  /** @type {string} */
  #referenceOrderId
  /** @type {number} */
  #orderId
  // `RG200210-436023-52` => 43602352
  // `RA210115-52` => 52

  constructor (jsonObject) {
    super()
    this.#lineNumber = Number.parseInt(jsonObject.lineNumber) || undefined
    this.#referenceOrderId = jsonObject.referenceOrderId
    this.#orderId = Number.parseInt(jsonObject.orderId) || undefined
    Object.freeze(this)
  }

  /**
   * Line item of the order
   * @return {number}
   */
  get lineNumber () {
    return this.#lineNumber
  }

  /**
   * Order identifier
   * @return {string}
   */
  get referenceOrderId () {
    return this.#referenceOrderId
  }

  /**
   * Order number from Order identifier
   * @return {number}
   */
  get orderId () {
    return this.#orderId
  }

  /**
   * Reference order id and line item number joined
   * to make the full parent reference line item id
   * @return {string}
   */
  get referenceLineItemId () {
    return [
      this.#referenceOrderId,
      this.#lineNumber
    ].filter(Boolean).join('-')
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      lineNumber: this.#lineNumber,
      referenceOrderId: this.#referenceOrderId,
      orderId: this.#orderId
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {ReferenceLineItemResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new ReferenceLineItemResponse(jsonObject)) || undefined
  }
}
